import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ColorFillPropertyType} from '@Components/color-fill';
import type {RGBA} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';

interface BaseItemShadowColorOptionProps {
  dropShadowColor: RGBA;
  className?: string;
  onClickColorFill(): void;
}

export function BaseItemCustomShadowColorOption({className = '', ...props}: BaseItemShadowColorOptionProps): ReactElement<any> | null {
  const getColorObjectForCustomShadow = (): ColorFillStorage[] => {
    return [
      {
        id: 'color-fill-custom-shadow',
        fillType: ColorFillPropertyType.SOLID,
        color: getColorObjectArrayFromFillColor([props.dropShadowColor]),
      },
    ];
  };
  return (
    <ContextualMenuColorFillOption
      id="custom-shadow-color-option"
      className={className}
      label={window.i18next.t('pmwjs_color')}
      data={getColorObjectForCustomShadow()}
      onClick={(): void => {
        props.onClickColorFill();
      }}
    />
  );
}
